import React from 'react';
import { useDispatch } from 'react-redux';
import {useRouter} from '../../../../../@casino/useRouter'
import {useFormik, FormikContext} from "formik";
import {setPostCreateBonuses} from '../../store/thunk/postCreateBonuses';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Dialog from '@material-ui/core/Dialog';

const useStyles = makeStyles(() => ({
    root: {
        padding: 30, 
        paddingTop: 0, 
        color: '#fff'
    },
    template: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        position: 'relative',
        display: 'inline-block',
        fontSize: '11px',
        color: 'hsla(0,0%,100%,.7)',
        marginBottom: '4px',
        verticalAlign: 'middle',
        fontFamily: "PT Sans, sans-serif",
    },
    selectTemplate: {
        border: 0,
        background: '#293356',
        boxShadow: 'inset 0 1px 0 0 hsl(0deg 0% 100% / 20%)',
        paddingLeft: 8,
        borderRadius: '4px',
        color: '#fff',
        cursor: 'pointer',
        display: 'table',
        borderSpacing: 0,
        borderCollapse: 'initial',
        height: '32px',
        outline: 'none',
        overflow: 'hidden',
        position: 'relative',
        width: '420px'
    },
    wrapLabelBonusName: {
        display: 'flex', flexDirection: 'column', width: 420, marginTop: 12
    },
    bonusName: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        position: 'relative',
        display: 'inline-block',
        fontSize: '11px',
        color: 'hsla(0,0%,100%,.7)',
        marginBottom: '4px',
        verticalAlign: 'middle',
        fontFamily: "PT Sans, sans-serif",
    },
    inputBonusName: {
        position: 'relative',
        borderRadius: '4px',
        height: '32px',
        overflow: 'hidden',
        boxShadow: '0 1px 0 0 hsl(0deg 0% 100% / 15%), inset 0 1px 0 0 rgb(0 0 0 / 15%)',
        border: 0,
        background: '#1c2542',
        color: '#fff',
        outline: 'none',
        paddingLeft: 8
    },
    create: {
        textTransform: 'uppercase',
        color: '#24263e',
        background: '#00a3f9',
        border: '1px solid #00a3f9',
        padding: '5px 10px',
        borderRadius: '16px',
        maxHeight: '48px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontWeight: 400,
        fontSize: 14,
        fontFamily: "PT Sans, sans-serif",
        userSelect: 'none',
        cursor: 'pointer',
    },
    cancel: {
        color: '#00a3f9',
        background: 'none',
        border: '1px solid #00a3f9',
        padding: '5px 10px',
        borderRadius: '16px',
        maxHeight: '48px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textTransform: 'uppercase',
        fontWeight: 400,
        fontSize: 14,
        fontFamily: "PT Sans, sans-serif",
        userSelect: 'none',
        cursor: 'pointer',
    },
    wrapButtonBlock: {
        marginTop: 20, 
        display: 'flex', 
        justifyContent: 'space-between', 
        width: 420, 
        alignItems: 'center'
    },
    text: {
        position: 'relative',
        borderRadius: '4px',
        height: '32px',
        overflow: 'hidden',
        boxShadow: '0 1px 0 0 hsl(0deg 0% 100% / 15%), inset 0 1px 0 0 rgb(0 0 0 / 15%)',
        border: 0,
        background: '#1c2542',
        color: '#fff',
        outline: 'none',
        paddingLeft: 8,
    },
}))

const SelectTemplate = () => {
    const router = useRouter();
    const classes = useStyles();
    const [showModal, setShowModal] = React.useState(false)
    const dispatch = useDispatch();
    const initialValues = {
        template: 'bonus-personal',
        bonus_name: '',
    }

    const onSubmit = (store) => {
        dispatch(setPostCreateBonuses({
            label: store.template,
            bonus_name: store.bonus_name 
        }, setShowModal))
    }

    const formik = useFormik({onSubmit, initialValues});

    return (
        <div className={classes.root}>
            <h3>Выбор шаблона бонуса</h3>
            <FormikContext.Provider value={formik}>
                <form onSubmit={formik.handleSubmit} >
                    <label htmlFor="template">
                        <span className={classes.template}>Шаблон</span>
                        <select id="template" name="template"
                            className={classes.selectTemplate}
                            value={formik.values.template} onChange={(v) => formik.setFieldValue('template', v.target.value)}
                        >
                            <option value="bonus-personal">Персональный бонус</option>
                            <option value="bonus-next-deposit">Бонус за последующие депозиты</option>
                            <option value="bonus-registration">Бонус за регистрацию</option>
                            <option value="bonus-everyday">Ежедневный бонус</option>
                            <option value="bonus-weekly">Еженедельный бонус</option>
                            <option value="bonus-promocode">Бонус по промокоду</option>
                            <option value="bonus-first-deposit">Бонус за первый депозит</option>
                            <option value="bonus-cashback">Кэшбек по окончанию баланса</option>
                        </select>
                    </label>
                    <label htmlFor="bonus_name" className={classes.wrapLabelBonusName}>
                        <span className={classes.bonusName}>Имя бонуса</span>
                        <input type="text" name="bonus_name" id="bonus_name"  className={classes.text}
                        value={formik.values.bonus_name} onChange={(v) => formik.setFieldValue('bonus_name', v.target.value)}
                        />
                    </label>
                    <div className={classes.wrapButtonBlock}>
                        <span className={classes.create} onClick={() => {
                            formik.submitForm();
                        }}>Создать</span>
                        <span className={classes.cancel}
                            onClick={() => router.history.push('/bonuses/bonus')}
                        >Отмена</span>
                    </div>
                </form>
            </FormikContext.Provider>
            <Dialog onClose={() => setShowModal(false)} open={showModal}>
                <div style={{width: 300, padding: 20, textAlign: 'center', display: 'flex', flexDirection: 'column'}}>
                    <span>Невозможно добавить бонус. Отредактируйте или удалите ранее созданный бонус.</span>
                    <span
                        onClick={() => setShowModal(false)}
                        style={{padding: '5px 15px', cursor: 'pointer', borderRadius: 4, background: "rgb(255, 206, 1)", marginTop: 12}}>ОК</span>
                </div>
            </Dialog>
        </div>
    )
}

export default SelectTemplate;